if (typeof G === 'undefined') G = {};
G.UI = G.UI || {};

// TODO: consider passing path to json instead of data directly
// so that jsons with child jsons can resolve path relative to their location
/**
 * @returns result {G.UI.UIElement}
 */
G.UI.createUIElement = function createUIElement(
  game, data, optScaleX, optScaleY, optGetJsonData, optFilterFunc
) {

  // imports
  var ElementType       = G.UI.ElementType;
  var ComponentType     = G.UI.ComponentType;
  var ExportsManager    = G.UI.ExportsManager;
  var createUIComponent = G.UI.createUIComponent;
  var addUIComponent    = G.UI.addUIComponent;

  var localize = G.txt;
  var defined  = G.Utils.defined;
  var clone    = G.Utils.clone;

  var Text      = G.Text;
  var Button    = G.Button;
  var makeImage = G.makeImage.bind(G);
  var makeGraphics  = function makeGraphics() { return game.add.graphics(); }
  var makeGroup     = function makeGroup()    { return game.add.group();    }
  var makeNineSlice = function makeNineSlice(cacheKey) {
    var cacheKeySplit = cacheKey.split('/');
    var spritesheet = cacheKeySplit[cacheKeySplit.length - 2];
    var frame       = cacheKeySplit[cacheKeySplit.length - 1];

    const assetsFolder = 'assets';
    var jsonKey = assetsFolder + '/' + cacheKey;

    if (G.json.hasOwnProperty(jsonKey)) {
      return G.Utils.NineSlice.fromJSON(jsonKey, 0, 0, 1, 1);
    } else {
      console.warn('No JSON found for ' + jsonKey + ' nine-slice!');
      return new PhaserNineSlice.NineSlice(
        0, 0,
        spritesheet, frame,
        1, 1,
        {
          left:   0,
          right:  0,
          top:    0,
          bottom: 0
        }
      );
    }
  };

  // end of imports - no `G.` beyond this point!

  var child = createChild(
    data.rootElement,
    {
      x: data.desiredSize[0],
      y: data.desiredSize[1]
    },
    defined(optScaleX, 1),
    defined(optScaleY, 1),
    optGetJsonData
  );

  return child;

  //

  function createChild(childData, parentSize, scaleX, scaleY, optGetJsonData, optParentExportFunc) {

    var exportsManager = new ExportsManager();

    var exportFunc = composeFuncs(
      null, optParentExportFunc,
      exportsManager, exportsManager.exportElement
    );

    var result = {
      rootElement: null,
      exports: exportsManager.result
    };

    // TODO: filter in json (e.g. are ads supported)

    if (canProcessChildData(childData)) {

      var child = createChildBase(childData, scaleX, scaleY);

      if (child) {
        result.rootElement = child;

        if (childData.exportNames) {
          childData.exportNames.forEach(function(exportName) {
            exportFunc(exportName, result);
          });
        }

        finishChildCreation(
          child, childData, parentSize, scaleX, scaleY, optGetJsonData, exportFunc
        );
      }
    }

    return result;

  }

  function canProcessChildData(childData) {
    return !optFilterFunc || optFilterFunc(childData.exportNames || []);
  }

  function createChildBase(childData, scaleX, scaleY) {
      switch (childData.type) {
        case ElementType.Rect:      return createGraphics(childData);
        case ElementType.Image:     return createImage(childData);
        case ElementType.NineSlice: return createNineSlice(childData);
        case ElementType.Group:     return createGroup();
        case ElementType.JSON:      return createGroup();
        case ElementType.Text:      return createText(childData, scaleX, scaleY);
        case ElementType.Button:    return createButton(childData);

        default: console.error('Unsupported element type:', childData.type);
      }
      return null;
  }

  function finishChildCreation(
    child, childData, parentSize, scaleX, scaleY, optGetJsonData, exportFunc
  ) {

    if (childData.name) {
      child.name = childData.name;
    }

    var layoutData = childData.layout || {};
    var uiComponent = createUIComponent(
      childData.type,
      parentSize.x, parentSize.y,
      layoutData,
      scaleX, scaleY
    );

    addUIComponent(child, uiComponent);

    if (childData.type === ElementType.Text) {
      // Text's width and height cannot be manipulated directly as it affects its scale
      // Hence using anchor for layouting
      child.anchor.setTo(
        uiComponent.pivot.x,
        uiComponent.pivot.y
      );
    } else {
      child.pivot.set(
        uiComponent.pivot.x * child.width,
        uiComponent.pivot.y * child.height
      );
    }

    if (layoutData.angle) {
      child.angle = layoutData.angle;
    }

    if (optGetJsonData && childData.type === ElementType.JSON) {
      var grandChild = handleJSONComponent(
        child,
        getComponentData(childData.components, ComponentType.JSON),
        uiComponent.desiredSize,
        optGetJsonData,
        exportFunc
      );
      if (grandChild) child.addChild(grandChild);
    }

    childData.children && childData.children.forEach(function(grandChildData) {
      var grandChildResult = createChild(
        grandChildData,
        uiComponent.desiredSize,
        scaleX, scaleY,
        optGetJsonData, exportFunc
      );
      if (grandChildResult.rootElement) {
        child.addChild(grandChildResult.rootElement);
      }
    });

    handleTransparencyComponent(
      child,
      getComponentData(childData.components, ComponentType.Transparency) || {}
    );

    handleVisibilityComponent(
      child,
      getComponentData(childData.components, ComponentType.Visibility) || {}
    );

    handleInputComponent(
      child,
      getComponentData(childData.components, ComponentType.Input) || {}
    );
  }

  //

  function createGraphics(childData) {
    var data = getComponentData(childData.components, ComponentType.Rect) || {};
    var child = makeGraphics();
    child.beginFill(
      !data.color ? 0x000000 : (
        (data.color[0] << 16) |
        (data.color[1] << 8) |
        (data.color[2] << 0)
      )
    );
    child.drawRect(0, 0, 16, 16);
    return child;
  }

  function createImage(childData) {
    var data = getComponentData(childData.components, ComponentType.Image) || {};
    var child = makeImage(0, 0, getCacheKey(data.cacheKey), 0, 0);
    if (!defined(data.antialiasing, true)) {
      child.smoothed = false;
    }
    return child;
  }

  function createNineSlice(childData) {
    var data = getComponentData(childData.components, ComponentType.Image) || {};
    var child = makeNineSlice(data.cacheKey);
    return child;
  }

  function createGroup() {
    var child = makeGroup();
    return child;
  }

  function createText(childData, scaleX, scaleY) {
    var data = getComponentData(childData.components, ComponentType.Text) || {};

    var textValue = (
      data.textLocalizationKey
        ? localize(data.textLocalizationKey)
        : data.textUnlocalized
    );
    textValue = textValue || '';

    var maxWidth = data.maxWidth;
    if (maxWidth) maxWidth *= scaleX;

    var maxHeight = data.maxHeight;
    if (maxHeight) maxHeight *= scaleY;

    var child = new Text(
      0, 0,
      textValue,
      data.style ? scaledTextStyle(data.style, Math.min(scaleX, scaleY)) : {},
      0,
      maxWidth, maxHeight,
      data.textWrap,
      data.align,
      true,
      true,
      data.scaleUniformly
    );

    return child;
  }

  function createButton(childData) {
    var data = getComponentData(childData.components, ComponentType.Image) || {};
    var child = new Button(0, 0, getCacheKey(data.cacheKey));
    if (defined(data.dontScaleOnClick)) {
      child.scaleOnClick = !data.dontScaleOnClick;
    }
    child.anchor.setTo(0);
    return child;
  }

  //

  function getComponentData(components, type) {
    if (!components) return;
    var found = components.find(function(component) {
      return component.type === type;
    });
    return found ? found.data : found;
  }

  //

  function handleTransparencyComponent(child, componentData) {
    child.alpha = defined(componentData.alpha, 1.0);
  }

  function handleVisibilityComponent(child, componentData) {
    if (componentData.hidden) {
      child.visible = false;
      child.exists = false;
    }
  }

  function handleInputComponent(child, componentData) {
    if (componentData.enabled) {
      child.inputEnabled = true;
    }
  }

  function handleJSONComponent(child, componentData, desiredSize, getJsonData, exportFunc) {
    if (!componentData || !componentData.cacheKey) return;
    var grandChildData = getJsonData(componentData.cacheKey);
    var grandChildResult = createChild(
      grandChildData.rootElement,
      desiredSize,
      // current scaleX / scaleY already incorporated via desiredSize
      desiredSize.x / grandChildData.desiredSize[0],
      desiredSize.y / grandChildData.desiredSize[1],
      getJsonData, exportFunc
    );
    return grandChildResult.rootElement;
  }

  //

  function scaledTextStyle(style, scale) {
    var result = style;
    if (style && style.fontSize) {
      result = clone(style);
      result.fontSize = result.fontSize.replace(
        /(\d+(?:\.\d+)?)/,
        function(str, strSize) { return String(Number(strSize) * scale); }
      );
      // TODO: consider scaling stroke width
    }
    return result;
  }

  function getCacheKey(url) {
    if (!url) return url;
    var index = url.lastIndexOf('/');
    return url.substr(index + 1);
  }

  //

  function composeFuncs(func1Ctx, func1, func2Ctx, func2) {
    return combined;
    function combined(/*arguments*/) {
      func1 && func1.apply(func1Ctx, arguments);
      func2 && func2.apply(func2Ctx, arguments);
    }
  }
};
